import React from "react";
import ReactDOM from "react-dom/client";
import Modal from "react-modal";

import App from "./App";

// Hidden from assistive technologies while a react-modal dialog is open.
Modal.setAppElement("#root");

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
);

const render = () =>
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    );

if (window.env) {
    render();
} else {
    const script = document.createElement("script");
    script.src = "/config.js";
    script.onload = () => {
        render();
    };
    document.head.appendChild(script);
}
